export default __webpack_public_path__ + "static/icon-hamburger-32f158cbd2ca1077f5b25226b8aab321.png";